export default __webpack_public_path__ + "static/media/03_danek_skvrnity_mezistromy-min.e0b75116.jpg";